/**
 * @description Does operations on Coworker profile
 * @see https://allen.ingka.com/docs/default/Component/pcmp-xdk/libraries/coworker/
 */
import type { XdkCoworkerProfile } from '@pcmp/xdk-types';

export type IsomConfigList = XdkCoworkerProfile.IsomConfigList;
export type Environment = XdkCoworkerProfile.Environment;
export type SupportedLocalesEntity = XdkCoworkerProfile.SupportedLocalesEntity;
export type ValueEntity = XdkCoworkerProfile.ValueEntity;
export type Preference = XdkCoworkerProfile.Preference;
export type CoworkerInfo = XdkCoworkerProfile.CoworkerInfo;
export type StorePreferencesConfig = XdkCoworkerProfile.StorePreferencesConfig;
export type CoworkerPreferences = XdkCoworkerProfile.CoworkerPreferences;
export type CoworkerStore = XdkCoworkerProfile.CoworkerStore;
export type CoworkerProfile = XdkCoworkerProfile.XdkCoworkerProfileInterface;
export type MsalProfile = XdkCoworkerProfile.MsalProfile;

// OT Frontend Custom

export enum StorePreferenceKeys {
    PreferredLocale = 'ikea.mtc.mfs.common.configattr.PRIMARY_LOCALE',
}
